export default __webpack_public_path__ + "static/media/BlackBloc.fea6ee55.jpg";